import type { MiraklListingIdentity } from '@noths/polaris-client-mirakl-tracking';
import { sendMiraklClickBeacon } from '@noths/polaris-client-mirakl-tracking/browser';

import { PUBLIC_API_BASE_PATH } from 'src/constants/environment';
import type { ProductSponsored } from 'src/redux/products/types/Product';

/**
 * Posts one `click` for a call to action on a sponsored tile (image, title or favourite) to this
 * app's own beacon route, which applies the consent and robot rules. The click is the event the
 * partner is billed on, so it is sent once per call to action and never retried from here.
 */
export const sendMiraklSponsoredClickBeacon = (
  sponsored: ProductSponsored,
  pageId: MiraklListingIdentity['pageId'],
): void => {
  sendMiraklClickBeacon(PUBLIC_API_BASE_PATH, {
    adId: sponsored.adId,
    pageId,
    referer: document.referrer,
    url: window.location.href,
  });
};
